import { match } from "ts-pattern";

import { useUser } from "../../Context/UserContext.js";
import { sessionOwnsAssessment } from "../Persons/involvementManagement.js";
import { useAssessment } from "./AssessmentContext.js";
import { AssessmentOverview } from "./AssessmentOverview.js";
import { AssessmentReview } from "./AssessmentReview.js";

/**
 * The screen an assessment opens on: the overview while it is being worked
 * on, and the whole of it, read only, while it waits for a decision or once it
 * is finished. A returned one opens read only for its owner, who reopens it
 * from there; anybody else is told on the overview that it is not open.
 */
export const AssessmentHome = () => {
  const { assessment } = useAssessment();
  const { user } = useUser();

  if (assessment === undefined) {
    return null;
  }

  return match(assessment.status)
    .with("open", () => <AssessmentOverview />)
    .with("returned", () =>
      sessionOwnsAssessment({ user, assessment }) ? (
        <AssessmentReview />
      ) : (
        <AssessmentOverview />
      ),
    )
    .with("submitted", "approved", "completed", () => <AssessmentReview />)
    .exhaustive();
};
